(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["driver-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var cards = Array.prototype.slice.call(root.querySelectorAll('.drv-card'));
      var tabs = root.querySelector('.drv-tabs');
      var seriesRow = root.querySelector('.drv-series');
      var input = root.querySelector('.drv-input');
      var form = root.querySelector('.drv-search');
      var empty = root.querySelector('.drv-empty');
      var pager = root.querySelector('.drv-pager');
      var perPage = parseInt(root.dataset.perPage, 10) || 9;
      var activeCat = 'all';
      var activeSeries = 'all';
      var page = 1;
      var lastKey = '';

      var cats = [];
      cards.forEach(function (card) {
        var cat = card.dataset.category || '其他';
        if (cats.indexOf(cat) === -1) cats.push(cat);
      });

      function addTab(label, value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'drv-tab';
        button.textContent = label;
        button.setAttribute('role', 'tab');
        button.dataset.cat = value;
        button.addEventListener('click', function () {
          activeCat = value;
          activeSeries = 'all';
          page = 1;
          render();
        });
        tabs.appendChild(button);
      }

      addTab(root.dataset.allLabel || '全部', 'all');
      cats.forEach(function (cat) { addTab(cat, cat); });

      function seriesOptions() {
        var list = [];
        cards.forEach(function (card) {
          if (activeCat !== 'all' && card.dataset.category !== activeCat) return;
          var series = card.dataset.series || '';
          if (series && list.indexOf(series) === -1) list.push(series);
        });
        return list;
      }

      function paintSeries() {
        var list = seriesOptions();
        var key = activeCat + '|' + list.join('|');
        if (activeSeries !== 'all' && list.indexOf(activeSeries) === -1) activeSeries = 'all';
        if (key === lastKey) {
          seriesRow.querySelectorAll('.drv-series-btn').forEach(function (button) {
            button.setAttribute('aria-pressed', button.dataset.series === activeSeries ? 'true' : 'false');
          });
          return;
        }
        lastKey = key;
        seriesRow.innerHTML = '';
        seriesRow.hidden = list.length === 0;
        list.forEach(function (name) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'drv-series-btn';
          button.textContent = name;
          button.dataset.series = name;
          button.setAttribute('aria-pressed', name === activeSeries ? 'true' : 'false');
          button.addEventListener('click', function () {
            activeSeries = activeSeries === name ? 'all' : name;
            page = 1;
            render();
          });
          seriesRow.appendChild(button);
        });
      }

      function matches() {
        var q = (input.value || '').trim().toLowerCase();
        return cards.filter(function (card) {
          var catOk = activeCat === 'all' || card.dataset.category === activeCat;
          var seriesOk = activeSeries === 'all' || card.dataset.series === activeSeries;
          var text = (card.dataset.search || '').toLowerCase();
          return catOk && seriesOk && (!q || text.indexOf(q) !== -1);
        });
      }

      function render() {
        paintSeries();
        var found = matches();
        var pages = Math.max(1, Math.ceil(found.length / perPage));
        if (page > pages) page = pages;
        var start = (page - 1) * perPage;

        cards.forEach(function (card) { card.hidden = true; });
        found.slice(start, start + perPage).forEach(function (card) { card.hidden = false; });
        empty.hidden = found.length !== 0;

        tabs.querySelectorAll('.drv-tab').forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.dataset.cat === activeCat ? 'true' : 'false');
        });

        pager.innerHTML = '';
        pager.hidden = pages < 2;
        if (pages > 1) {
          for (var i = 1; i <= pages; i++) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'drv-page';
            btn.textContent = String(i);
            if (i === page) btn.setAttribute('aria-current', 'page');
            btn.addEventListener('click', function (event) {
              page = parseInt(event.currentTarget.textContent, 10);
              render();
              root.querySelector('.drv-grid').scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            pager.appendChild(btn);
          }
        }

        if (window.history && window.history.replaceState) {
          var params = new URLSearchParams(window.location.search);
          if (input.value.trim()) params.set('q', input.value.trim());
          else params.delete('q');
          if (activeCat !== 'all') params.set('cat', activeCat);
          else params.delete('cat');
          if (activeSeries !== 'all') params.set('series', activeSeries);
          else params.delete('series');
          var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          window.history.replaceState({}, '', next);
        }
      }

      var params = new URLSearchParams(window.location.search);
      if (params.get('q')) input.value = params.get('q');
      if (params.get('cat') && cats.indexOf(params.get('cat')) !== -1) activeCat = params.get('cat');
      if (params.get('series')) activeSeries = params.get('series');

      input.addEventListener('input', function () {
        page = 1;
        render();
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        page = 1;
        render();
      });
      render();
    }

    document.querySelectorAll('[data-driver-library]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-driver-library]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manual-library"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var cards = Array.prototype.slice.call(root.querySelectorAll('.ml-card'));
      var tabs = root.querySelector('.ml-tabs');
      var input = root.querySelector('.ml-input');
      var form = root.querySelector('.ml-search');
      var empty = root.querySelector('.ml-empty');
      var pager = root.querySelector('.ml-pager');
      var perPage = parseInt(root.dataset.perPage, 10) || 9;
      var activeCat = 'all';
      var page = 1;

      var cats = [];
      cards.forEach(function (card) {
        var cat = card.dataset.category || 'General';
        if (cats.indexOf(cat) === -1) cats.push(cat);
      });

      function addTab(label, value) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ml-tab';
        button.textContent = label;
        button.setAttribute('role', 'tab');
        button.dataset.cat = value;
        button.addEventListener('click', function () {
          activeCat = value;
          page = 1;
          render();
        });
        tabs.appendChild(button);
      }

      addTab(root.dataset.allLabel || 'All', 'all');
      cats.forEach(function (cat) { addTab(cat, cat); });

      function matches() {
        var q = (input.value || '').trim().toLowerCase();
        return cards.filter(function (card) {
          var catOk = activeCat === 'all' || card.dataset.category === activeCat;
          var text = (card.dataset.search || '').toLowerCase();
          return catOk && (!q || text.indexOf(q) !== -1);
        });
      }

      function render() {
        var found = matches();
        var pages = Math.max(1, Math.ceil(found.length / perPage));
        if (page > pages) page = pages;
        var start = (page - 1) * perPage;

        cards.forEach(function (card) { card.hidden = true; });
        found.slice(start, start + perPage).forEach(function (card) { card.hidden = false; });

        empty.hidden = found.length !== 0;
        tabs.querySelectorAll('.ml-tab').forEach(function (tab) {
          tab.setAttribute('aria-selected', tab.dataset.cat === activeCat ? 'true' : 'false');
        });

        pager.innerHTML = '';
        pager.hidden = pages < 2;
        if (pages > 1) {
          for (var i = 1; i <= pages; i++) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'ml-page';
            btn.textContent = String(i);
            if (i === page) btn.setAttribute('aria-current', 'page');
            btn.addEventListener('click', function (event) {
              page = parseInt(event.currentTarget.textContent, 10);
              render();
              root.querySelector('.ml-grid').scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            pager.appendChild(btn);
          }
        }

        if (window.history && window.history.replaceState) {
          var params = new URLSearchParams(window.location.search);
          if (input.value.trim()) params.set('q', input.value.trim());
          else params.delete('q');
          if (activeCat !== 'all') params.set('cat', activeCat);
          else params.delete('cat');
          var next = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
          window.history.replaceState({}, '', next);
        }
      }

      var params = new URLSearchParams(window.location.search);
      if (params.get('q')) input.value = params.get('q');
      if (params.get('cat') && cats.indexOf(params.get('cat')) !== -1) activeCat = params.get('cat');

      input.addEventListener('input', function () {
        page = 1;
        render();
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        page = 1;
        render();
      });
      render();
    }

    document.querySelectorAll('[data-manual-library]').forEach(init);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-manual-library]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
